import React from 'react';

/* eslint-disable max-len */
export const ArrowRight = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" {...props}>
      <path
        d="M0 7C0 6.3125 0.5625 5.75 1.25 5.75H9.84375L7.09375 2.875C6.625 2.375 6.65625 1.59375 7.15625 1.09375C7.65625 0.625 8.4375 0.65625 8.90625 1.15625L13.6562 6.15625C14.125 6.625 14.125 7.40625 13.6562 7.875L8.90625 12.875C8.6875 13.125 8.34375 13.25 8 13.25C7.71875 13.25 7.40625 13.1562 7.15625 12.9062C6.65625 12.4375 6.625 11.6562 7.09375 11.1562L9.84375 8.25H1.25C0.5625 8.25 0 7.71875 0 7Z"
        fill="white"
      />
    </svg>
  );
};
